import e from "../managers/braze-instance.js";
import { MUST_BE_IN_APP_MESSAGE_WARNING as or } from "../common/constants.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import se from "./in-app-message-manager-factory.js";
import r from "../../shared-lib/braze-shared-lib.js";
import tt from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as et } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageButtonClick(o, t) {
  var s;
  if (!e.rr()) return !1;
  if (!(o instanceof InAppMessageButton))
    return r.j.error("button must be an InAppMessageButton object"), !1;
  if (!(t instanceof InAppMessage)) return r.j.error(or), !1;
  const n = se.m().Xi(o, t);
  if (n.O)
    for (let r = 0; r < n.ve.length; r++)
      et.er().be(
        tt.ro,
        [
          t.triggerId,
          null === (s = o.id) || void 0 === s ? void 0 : s.toString(),
        ],
        n.ve[r],
      );
  return n.O;
}
